// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._v5641ppt{transition:color .15s,opacity .15s}._19bvze3t{padding-left:var(--ds-space-0,0)}\n._ca0qze3t{padding-top:var(--ds-space-0,0)}\n._n3tdze3t{padding-bottom:var(--ds-space-0,0)}\n._tzy4kb7n{opacity:1}\n._u5f3ze3t{padding-right:var(--ds-space-0,0)}\n._30l3s4qr:hover{color:var(--ds-icon-danger,#c9372c)}\n@media (hover:hover) and (pointer:fine){._1mhjgrf3{opacity:0!important}}", ""]);
// Exports
module.exports = exports;
